// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2mDzI","sendOtp":"AuthorizeToLogin_sendOtp__BPGgQ"};